module.exports = __webpack_public_path__ + "img/1.dd24936a.png";